import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { EDropdownPlacement } from '@aquariuxfintech/aqx-trader-react-ui/dropdown';
import { ESpacing, ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UISelectPicker, { EUISelectPickerVariant } from '@aquariuxfintech/aqx-trader-react-ui/select-picker';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { getCountryLabelFromSelectedCountry } from '@aqx-core/common/format/country';
import { useCountryOptions } from '@aqx-core/common/hooks/sign-up/use-country-options';
import { useSignUpDemo } from '@aqx-core/common/services/sign-up-demo';

interface ICountrySelectFieldProps {
  onCountryChange: (nextValue: string) => void;
  value: string;
  error: string | undefined;
}

const CountrySelectField = ({ onCountryChange, value, error }: ICountrySelectFieldProps) => {
  const { t } = useTranslation();
  const { countries } = useSignUpDemo();

  const selectedCountry = countries.find((c) => c.countryCode === value);

  const countryOptions = useCountryOptions(countries);

  return (
    <StyledContainer>
      <UIText typography={ETypography.TEXT_L_REGULAR}>{t('Country of residence')}</UIText>
      <StyledInputSelectContainer>
        <UISelectPicker<string>
          variant={EUISelectPickerVariant.SEARCHABLE_SELECTOR}
          size="large"
          options={countryOptions}
          selectedValue={value}
          onSelect={onCountryChange}
          dropdownPlacement={EDropdownPlacement.BOTTOM_START}
          dropdownWidth="240px"
          dropDownMaxHeight={200}
          valueLabel={getCountryLabelFromSelectedCountry(selectedCountry)}
          useLabelToSearch
          placeholder={t('Select Country of residence')}
          searchPlaceholder={t('Search')}
          inputProps={{ autoFocus: true, error }}
        />
      </StyledInputSelectContainer>
    </StyledContainer>
  );
};

export default CountrySelectField;

const StyledContainer = styled.div``;

const StyledInputSelectContainer = styled.div`
  display: flex;
  margin-top: ${ESpacing.XXXS}px;
`;
